<template>
    <div class=" flex flex-col">
        <div class="mt-3 mb-10 flex justify-between space-x-6">
            <h4 class=" text-2xl font-apple">New Todo</h4>
             <span v-if="success" class=" bg-green-600 text-center right text-medium rounded px-2 py-2 italic text-white">The todo has been added successfull</span>
        </div>
        
        <ul class="w-full">
            <li>
                <input type="text" v-model="form.title" id=""
                    class="w-5/12 border-2 rounded outline-none   py-1 text-base px-2 border-gray-800 "
                    placeholder="Type Title Here">

                    <span v-if="form.hasError('title')" v-text="form.errorOut('title')" class="block mt-1 italic text-sm text-red-700"></span>
            </li>
            <li class="mt-8">
                <textarea v-model="form.description" id="" class="w-5/12 h-32 p-2 rounded text-base border-2 border-gray-800"
                    placeholder="Description In Here"></textarea>
                    <span v-if="form.hasError('description')" v-text="form.errorOut('description')" class="block mt-1 italic text-sm text-red-700"></span>
            </li>
            <li class="mt-4 flex ">
                <button class="p-2 rounded bg-gray-700 hover:bg-gray-900 text-white " @click="saveTodo">Save Todo</button>
               
            </li>
        </ul>


    </div>
</template>

<script>
import axios from 'axios'
import MyForm from '../../../frontend/src/MyForm'
    export default {

        data() {
            return {
                form : new MyForm({
                    title: '',
                    description: ''
                }),

                success: false
            }
        },

        

        methods: {
            saveTodo(){
             axios.post('/api/todos', this.form)
             .then(() => {
                 this.success = true;
                 this.form.reset();
                 setTimeout(() => {
                     this.success = false;
                 }, 5000);
             }).catch(error => {

                //  console.log(error.response.data.errors)
                 this.form.error = error.response.data.errors;
             })   
            }
        }

    }

</script>